<div class="wl-tabs-container wl-vertical-tabs-container mct-flex mct-row mct-justify-start mct-items-start"
  [ngClass]="{ 'wl-non-windowed-tabs': !windowed, 'wl-windowed-tabs': windowed }">
  <div #tabDropdownOuterContainer class="wl-vertical-tabs-nav-outer-container">
    <div #tabDropdownContainer class="wl-vertical-tabs-nav-container collapse" [ngClass]="{ in: showTabNav }">
      <ul wlx-tab-view class="wl-vertical-tabs" [collapseSubTabs]="collapseSubTabs" [tabs]="childTabs"
        *ngIf="childTabs?.length"></ul>
    </div>
  </div>
  <button pButton type="button" #tabToggle type="button" class="wl-tab-nav-toggle visible-xs-inline-block"
    (click)="tabNavToggleClicked()">
    <span class="sr-only">Toggle tabs</span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </button>
  <div class="wl-tab-content-container mct-flex-1-1-0"><ng-content></ng-content></div>
</div>